import { Component, OnInit } from '@angular/core';
import { LocalService } from '../../_services/local.service';
import { NotificationService } from '../../_services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { RequestService } from '../../modules/request/request.service';
import { RequestMasterModel } from '../../modules/request/request-model';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-request-email',
  templateUrl: './request-email.component.html',
  styleUrls: ['./request-email.component.scss']
})
export class RequestEmailComponent implements OnInit {

  public Id: number;
  public Name: string;
  public Message: string = "";
  public openRejectRequestDialog = false;
  public openApprovedRequestDialog = false;
  public openReturnRequestDialog = false;
  public user: any;
  public requestMaster: RequestMasterModel = new RequestMasterModel();
  constructor(public _notificationService: NotificationService,
    public _requestService: RequestService,
    public _localService: LocalService,
    private route: ActivatedRoute,
   public _authenticationServie: AuthenticationService) {
  }

  ngOnInit() {
    debugger
    this.user = this._authenticationServie.getUser();
    this.route.queryParams.subscribe(params => {
      this.Id = params['id'];
      this.Name = params['name'];
    });

    if(this.Name === "approved"){
      this.ApprovedRequestDialog(this.Id);
    }
    else if(this.Name === "return"){
      this.ReturnRequestDialog(this.Id);
    }
    else{
      this.RejectRequestDialog(this.Id);
    }

  }

  public onApprovedRequestSubmit(status) {
    this.openApprovedRequestDialog = false;
    this._requestService.ApprovedRequest(this.requestMaster.Id, this.user.Id, this.requestMaster.ApprovedRemarks).subscribe((res: any) => {
      this.Message = "Approved"
      this._notificationService.notify("success", "Request Approved Successfully");

    }, err => {

      this._notificationService.notify("danger", err.msg);

    });
    this.requestMaster = new RequestMasterModel();
  }

  RejectRequestDialog(e){
    this.openRejectRequestDialog = true;
    this.requestMaster.Id = e;
  }

  public closeReject(){
    this.openRejectRequestDialog = false;
    this.openApprovedRequestDialog = false;
    this.Message = "";
  }

  public onRejectRequestSubmit(status){
    this.openRejectRequestDialog = false;
    this._requestService.RejectRequest(this.requestMaster,this.user.Id).subscribe((res: any) => {
      this.Message = "Reject"
      this._notificationService.notify("success", "Request Reject Successfully");
       
     }, err => {

       this._notificationService.notify("danger", err.msg);

     });
    this.requestMaster = new RequestMasterModel();
  }  
  ApprovedRequestDialog(e) {
    this.openApprovedRequestDialog = true;
    this.requestMaster.Id = e;
  }

  public onReturnRequestSubmit(status) {
    debugger
    this.openReturnRequestDialog = false;
    this._requestService.ReturnRequest(this.requestMaster.Id, this.user.Id, this.requestMaster.ReturnReason).subscribe((res: any) => {
      debugger
      this.Message = "Return"
      this._notificationService.notify("success", "Request Approved Successfully");

    }, err => {

      this._notificationService.notify("danger", err.msg);

    });
    this.requestMaster = new RequestMasterModel();
  }

  ReturnRequestDialog(e) {
    this.openReturnRequestDialog = true;
    this.requestMaster.Id = e;
  }
}
